import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import { DynamicPayload } from "@/utils/types/dynamicModule";

const basePath = "/formily/dynamic-model";

class DynamicModuleService {
  getGridColItems = async (
    modelName: string,
    page: number,
    pageSize: number,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!modelName) {
      throwError("Model name is required", "DynamicModuleService");
    }
    const response = await get(`${basePath}/${modelName}/grid_data/`, {
      params: {
        page,
        page_size: pageSize,
      },
      notifyMessage,
    });
    return response.grid_data;
  };

  getGridCoByConfig = async (
    modelName: string,
    page: number,
    pageSize: number,
    columns: string[],
    paramsFilter: any,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!modelName) {
      throwError("Model name is required", "DynamicModuleService");
    }
    const response = await get(`${basePath}/${modelName}/`, {
      params: {
        offset: (page - 1) * pageSize,
        limit: pageSize,
        columns: JSON.stringify(columns),
        ...paramsFilter,
      },
      notifyMessage,
    });
    return response;
  };

  getItemById = async (
    modelName: string,
    id: string,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!modelName || !id) {
      throwError("Model name and ID are required", "DynamicModuleService");
    }
    return await get(`${basePath}/${modelName}/${id}/`, { notifyMessage });
  };

  createItem = async (
    modelName: string,
    payload: DynamicPayload,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!modelName || !payload) {
      throwError("Model name and payload are required", "DynamicModuleService");
    }
    return await post(`${basePath}/${modelName}/`, payload, { notifyMessage });
  };

  updateItem = async (
    modelName: string,
    id: string,
    payload: DynamicPayload,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!modelName || !id || !payload) {
      throwError(
        "Model name, ID, and payload are required",
        "DynamicModuleService"
      );
    }
    return await put(`${basePath}/${modelName}/${id}/`, payload, {
      notifyMessage,
    });
  };

  deleteItem = async (
    modelName: string,
    id: string,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!modelName || !id) {
      throwError("Model name and ID are required", "DynamicModuleService");
    }
    return await del(`${basePath}/${modelName}/${id}/`, { notifyMessage });
  };

  bulkDeleteItems = async (
    modelName: string,
    ids: string[],
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!modelName || !ids) {
      throwError("Model name and IDs are required", "DynamicModuleService");
    }
    return await post(
      `${basePath}/${modelName}/bulk-delete/`,
      { ids },
      { notifyMessage }
    );
  };

  getDropDownData = async (
    modelName: string,
    notifyMessage?: boolean
  ): Promise<any> => {
    if (!modelName) {
      throwError("Model name is required", "DynamicModuleService");
    }
    return await get(`${basePath}/${modelName}/drop_down_data/`, {
      notifyMessage,
    });
  };
}

const instance = new DynamicModuleService();
export default instance;
